module.exports = __webpack_public_path__ + "static/naslovna-radovi-a55e4310d25c89807055f3de97964221.jpg";